/* Tracking Event View Current Candidate Election Filter
 *
 * Angular Module: trackerbase-app.views.tracking-event-editor.current-candidacies-filter
 * Filter exposed as: tbCurrentCandidacies
 */

import angular from "angular";

function TargetCurrentCandidaciesFilterFactory() {

    function TargetCurrentCandidaciesFilter(trackingTarget, eventDate) {
        if (trackingTarget.targetElections.length <= 1) {
            return trackingTarget.targetElections;
        }
        else if (angular.isDate(eventDate)) {
            let electionsAtTimeOfEvent = 
                trackingTarget.getTargetElectionsOnDate(eventDate);

            if (electionsAtTimeOfEvent.length === 0) {
                return trackingTarget
                        .getTargetNextCandidacyAfterDate(eventDate);
            }
            else {
                return electionsAtTimeOfEvent;
            }
        }
        else {
            return trackingTarget.targetElections;
        }    
    }

    return TargetCurrentCandidaciesFilter;
}

TargetCurrentCandidaciesFilterFactory.$inject = [];

export default angular
    .module(
        "trackerbase-app.views.tracking-event-editor.current-candidacies-filter", []
    )
    .filter("tbCurrentCandidacies", TargetCurrentCandidaciesFilterFactory)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-event-editor/CurrentCandidaciesFilter.js
// module id = nuhX
// module chunks = 1